// Decorative Heroes of the Storm artwork used by the redesign.
// Official art from heroesofthestorm.blizzard.com, used under Blizzard's
// Community Competition License. Each slot takes an image plus the
// object-position used to crop it, so art can be swapped without touching
// the components.
import heroXal from '../assets/art/hero-xal.webp'
import nexusPlatform from '../assets/art/nexus-platform.webp'
import bannerOrphea from '../assets/art/Orphea_Key_Artwork.webp'
import weekend1 from '../assets/art/weekend-1.webp'
import weekend2 from '../assets/art/weekend-2.webp'
import ctaWhitemane from '../assets/art/cta-whitemane.webp'

export const ART = {
  // Right side of the hero, fading in behind the title.
  hero: { src: heroXal, position: '50% 20%' },
  // Behind the prize pool panel.
  overview: { src: nexusPlatform, position: '70% 50%' },
  // Wide divider between the overview and the schedule, cropped to Orphea's face.
  banner: { src: bannerOrphea, position: '44% 18%' },
  // Backgrounds for the two weekend panels.
  weekends: [
    { src: weekend1, position: '50% 40%' },
    { src: weekend2, position: '50% 40%' },
  ],
  // Background of the closing registration panel.
  cta: { src: ctaWhitemane, position: '50% 30%' },
}
